<template>
<div  :aria-busy="loading ? 'true' : 'false'">

		<section class="content__custom" v-if="!loading">
			<div class="main-title" v-if="intent.tag">
				<h1 class="themes">
					Seguidores interessados no {{ 'theme' | translate | lowercase }}: {{ intent.tag }}
				</h1>
			</div>

				<div v-if="intent.recipients">
					<div v-if="intent.recipients.length >= 1">
						<table class="table--fixed table-navigation">
							<thead>
								<tr>
									<th class="name-cell">{{ 'name' | translate | titleCase }}</th>
									<th class="email-cell">{{ 'email' | translate | titleCase }}</th>
									<th class="phone-cell">{{ 'phone' | translate | titleCase }}</th>
									<th class="groups-cell">{{ 'groups' | translate | titleCase }}</th>
									<th class="intention-cell">{{ 'intentions' | translate | titleCase }}</th>
									<!-- <th class="gender-cell">{{ 'gender' | translate | titleCase }}</th> -->
									<th class="platform-cell">{{ 'network' | translate | titleCase }}</th>
								</tr>
							</thead>
							<tfoot v-if="intent.recipients.length >= 10">
								<tr>
									<th class="name-cell">{{ 'name' | translate | titleCase }}</th>
									<th class="email-cell">{{ 'email' | translate | titleCase }}</th>
									<th class="phone-cell">{{ 'phone' | translate | titleCase }}</th>
									<th class="groups-cell">{{ 'groups' | translate | titleCase }}</th>
									<th class="intention-cell">{{ 'intentions' | translate | titleCase }}</th>
									<!-- <th class="gender-cell">{{ 'gender' | translate | titleCase }}</th> -->
									<th class="platform-cell">{{ 'network' | translate | titleCase }}</th>

								</tr>
							</tfoot>
							<tbody>
								<tr v-for="person in intent.recipients" :key="person.id" @click="detailsSupporters(person.id)">
									<td :title="'name' | translate" class="name-cell">{{ person.name }}</td>
									<td :title="'email' | translate" class="email-cell">{{ person.email }}</td>
									<td :title="'phone' | translate" class="intention-cell">{{ person.cellphone }}</td>
									<td :title="'groups' | translate" class="groups-cell">{{ person.groups.length }}</td>
									<td :title="'intentions' | translate" class="intention-cell">{{ person.intents.length }}</td>
									<!-- <td :title="'gender' | translate" class="gender-cell"><i v-if="person.gender == 'F'" class="fas fa-female"></i><i class="fas fa-male" v-else></i></td> -->
									<td :title="'network' | translate" class="platform-cell"><i v-if="person.platform == 'facebook'" class="fas fa-facebook"></i><i v-if="person.platform == 'twitter'" class="fas fa-twitter"></i></td>
								</tr>
							</tbody>
						</table>
					</div>
					<div v-else>
						<div class="content-empty">
							<p class="empty-state">{{ 'no-supporters-intents' | translate | capitalize }}</p>
						</div>
					</div>
				</div>

		</section>
	</div>
</div>
</template>
<script>
export default {
	name: 'details-intents',
	data() {
		return {
			loading: false,
			session: {
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
				intentId: this.$route.params.id,
			},
		};
	},
	mounted() {
		this.toggleLoading();
		this.$store.dispatch('getIntent', this.session)
			.then(() => {
				this.toggleLoading();
			})
			.catch(() => {
				this.toggleLoading();
			});
	},
	computed: {
		intent() {
			return this.$store.state.entity.intent;
		},
	},
	methods: {
		detailsSupporters(id) {
			this.$router.push({ path: '/seguidor', query: { id } });
		},
		toggleLoading() {
			this.loading = !this.loading;
		},
	},
};
</script>



// WEBPACK FOOTER //
// _source/javascripts/modules/entity/intentsDetails.vue